export default {
  title: 'HubRise',
  setup: {
    description: 'Jaa tietoja muiden sovellusten kanssa.',
  },
  form: {
    is_menus_sync_enabled: 'Synkronoi ruokalista',
    is_inventory_sync_enabled: 'Synkronoi varasto',
    is_opening_hours_sync_enabled: 'Synkronoi aukioloajat',
    is_order_acceptance_mode_sync_enabled: 'Synkronoi kiireinen/keskeytetty-tila',
    variant_ref: 'Ruokalistan versio',
    variant_ref_default: 'Oletus',
  },
  tabs: {
    settings: 'Asetukset',
    service_types: 'Palvelutyypit',
    payments: 'Maksut',
    charges: 'Maksut',
    deals: 'Tarjoukset',
    discounts: 'Alennukset',
    customers: 'Asiakkaat',
  },
  customers: {
    description:
      'Poista yksittäisen asiakkaan tiedot HubRisen puolelta, esimerkiksi tietojen poistopyynnön jälkeen. Tätä ei voi perua.',
    customer: 'Asiakas',
    placeholder: 'Hae nimellä, sähköpostilla tai puhelinnumerolla…',
  },
  mapping: {
    description:
      'Yhdistä kukin {{provider}}-kohde vastaavaan HubRise-arvoon ja -nimeen. Jätä rivi tyhjäksi käyttääksesi {{provider}}-oletuksia.',
    entity: '{{provider}}',
    value: 'HubRise-arvo',
    name: 'HubRise-nimi',
  },
  connecting: {
    title: 'Viimeistellään HubRise-yhteyttä…',
    description: 'Tämä kestää muutaman sekunnin. Pidä sivu auki.',
    error_title: 'HubRise-yhteyden muodostaminen kestää odotettua kauemmin',
    error_description:
      'HubRise valtuutettiin, mutta yhteyttä ei ole vielä vahvistettu. Tarkista hetken kuluttua uudelleen — jos tämä toistuu, aloita yhdistäminen uudelleen.',
  },
  buttons: {
    connect: 'Yhdistä HubRiseen',
    check_again: 'Tarkista uudelleen',
    disconnect: 'Katkaise yhteys',
    go_to_hubrise: 'Siirry HubRiseen',
    pull_menus: 'Hae menu',
    pull_inventory: 'Hae varasto',
    save: 'Tallenna',
    delete_customer: 'Poista asiakas',
  },
  toasts: {
    connected: 'HubRise on yhdistetty',
    connect_cancelled: 'HubRise-yhdistäminen peruutettiin',
    connect_error: 'HubRise-yhteyden muodostaminen epäonnistui',
    connect_timeout: 'HubRise-yhteyttä ei voitu vielä vahvistaa',
    local_changes_replaced: 'HubRise-asetuksia päivitettiin muualla — tallentamattomat muutoksesi korvattiin',
    disconnect_success: 'HubRisen yhteys on katkaistu',
    disconnect_error: 'HubRisen yhteyden katkaiseminen epäonnistui',
    pull_menus_success: 'Menun synkronointi on käynnistetty',
    pull_menus_error: 'Menun haku epäonnistui',
    pull_inventory_success: 'Varaston synkronointi on käynnistetty',
    pull_inventory_error: 'Varaston haku epäonnistui',
    save_success: 'HubRise-asetukset on tallennettu',
    save_error: 'HubRise-asetusten tallentaminen epäonnistui',
    load_customers_error: 'Asiakkaiden lataaminen epäonnistui',
    delete_customer_success: 'Asiakastietojen poistoa on pyydetty',
    delete_customer_error: 'Asiakastietojen poistaminen epäonnistui',
  },
  delete_customer_confirm: {
    title: 'Poistetaanko tämä asiakas HubRisesta?',
    description: 'Asiakkaan tiedot poistetaan HubRisen puolelta. Tätä ei voi perua.',
    ok: 'Poista',
    cancel: 'Peruuta',
  },
  disconnect_confirm: {
    title: 'Katkaistaanko yhteys HubRiseen?',
    description: 'Tämä pysäyttää menujen, varaston ja tilausten synkronoinnin HubRisen kanssa.',
    ok: 'Katkaise yhteys',
    cancel: 'Peruuta',
  },
  connected: {
    title: 'Yhdistetty HubRiseen',
    description: 'HubRise-tilisi on yhdistetty onnistuneesti.',
    account: 'Tili',
    location: 'Sijainti',
    catalog: 'Luettelo',
    customer_list: 'Asiakaslista',
  },
};
